//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LinkedApplicationsInfo from "./linked-applications-info";
import EmptyApplicationHandler from "./empty-application-handler";
import AddClientModal from "../../../../clients/applications/application/applications-list/components/add-client-modal";
import CollapsibleCard from "@Broker/@Modules/clients/board/client-profile/components/shared/collapsible-card.vue";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "LinkedApplications",
  components: {
    EmptyApplicationHandler,
    LinkedApplicationsInfo,
    AddClientModal,
    CollapsibleCard
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    username: {
      type: String,
      default: null
    },
    applications: {
      type: Object,
      default: () => ({})
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    collapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      modalData: {}
    };
  },
  computed: {
    hasApplications() {
      return !isEmpty(this.applications);
    },
    loadingProfileDetails() {
      return isEmpty(this.profile);
    }
  },
  methods: {
    resetData() {
      this.modalData = {};
    },
    handleCreate() {
      this.modalData = {
        clientDetails: this.profile,
        agentUsername: this.profile.owner.username,
        additional: this.hasApplications,
        clientProfileId: this.clientProfileId,
        method: "full-application-method",
        clientUsername: this.username
      };
      this.$refs.addClient.show();
    },
    handleSave() {
      this.$emit("save");
    },
    handleOpenDuplicateModal(data) {
      this.$emit("duplicate-modal-opened", data);
    },
    handleCopyApplication(application) {
      this.$emit("copy-application", application);
    }
  }
});